import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const DocketwiseActions = {
  docketwiseAuth: async _ => {
    return axiosRequest.
      get('/users/docketwise/authorize').
      then(({ data }) => {
        window.location.assign(data.url)
      }).
      catch(handleError)
  },
  docketwiseSaveToken: async (_, payload) => {
    return axiosRequest.
      post('/users/docketwise/save_token', {
        token: payload,
      }).
      catch(handleError)
  },
  docketwiseRemoveToken: async _ => {
    return axiosRequest.
      delete('/users/docketwise/remove_token').
      catch(handleError)
  },
  docketwiseRenewToken: async _ => {
    return axiosRequest.
      post('/users/docketwise/refresh_token').
      catch(handleError)
  },
  docketwiseCreateContact: async (_, id) => {
    return axiosRequest.
      post(`/parties/${id}/docketwise/contacts`).
      catch(handleError)
  },
  docketwiseUpdateContact: async (_, { party }) => {
    return axiosRequest.
      patch(`/parties/${party.id}/docketwise/contacts/${party.docketwise_id}`).
      catch(handleError)
  },
  docketwiseRemoveContact: async (_, { party, deleteFromDocketwise }) => {
    return axiosRequest.
      delete(`/parties/${party.id}/docketwise/contacts/${party.docketwise_id}`, {
        delete_from_docketwise: deleteFromDocketwise,
      }).
      catch(handleError)
  },
}
